import type { IconButtonProps } from '@mui/material/IconButton';

import { useCurrentUserPresenceShine } from 'src/hook/use-user-presence';
import ChangePasswordForm from 'src/pages/auth/components/change-password/ChangePasswordForm';

import { CustomPopover } from 'src/components/custom-popover';

import { AccountButton } from './account-button';
import { useAccountDrawer } from './use-account-drawer';
import { AccountDrawerContent } from './account-drawer-content';

// ----------------------------------------------------------------------

export type AccountDrawerProps = IconButtonProps & {
  data?: {
    id: string;
    label: string;
    href: string;
    icon?: React.ReactNode;
    info?: React.ReactNode;
  }[];
};

export function AccountDrawer({ data = [], sx, ...other }: AccountDrawerProps) {
  const {
    t,
    open,
    anchorEl,
    onOpen,
    onClose,
    loginApiData,
    registered,
    isConnecting,
    reconnectSIP,
    profileImgUrl,
    selectedContactId,
    changePassWordMenu,
    handleSelectContact,
    signOutHandler,
    activeSubscription,
    isView,
    isVoiceFeatureVisible,
    currentUserId,
  } = useAccountDrawer();

  const { canViewUserPresence, isUserOnline } = useCurrentUserPresenceShine(currentUserId);
  const presenceShow = !!(canViewUserPresence && currentUserId);
  const presenceOnline = !!(currentUserId && isUserOnline(currentUserId));

  return (
    <>
      <AccountButton
        onClick={onOpen}
        photoURL={profileImgUrl}
        displayName={
          loginApiData && 'firstName' in loginApiData && 'lastName' in loginApiData
            ? loginApiData.firstName || loginApiData?.lastName
            : ''
        }
        registered={registered}
        showPresenceDot={presenceShow}
        presenceUserId={currentUserId}
        presenceOnline={presenceOnline}
        sx={sx}
        {...other}
      />

      <ChangePasswordForm
        open={changePassWordMenu.value}
        onCloseHandler={() => changePassWordMenu.onFalse()}
      />

      <CustomPopover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        slotProps={{ arrow: { offset: 20 } }}
      >
        <AccountDrawerContent
          t={t}
          data={data}
          onClose={onClose}
          loginApiData={loginApiData}
          registered={registered ?? false}
          isConnecting={isConnecting ?? false}
          reconnectSIP={reconnectSIP ?? (() => {})}
          profileImgUrl={profileImgUrl}
          selectedContactId={selectedContactId}
          handleSelectContact={handleSelectContact}
          signOutHandler={signOutHandler}
          activeSubscription={activeSubscription}
          isView={isView}
          isVoiceFeatureVisible={isVoiceFeatureVisible}
          accountPresenceShow={presenceShow}
          accountPresenceOnline={presenceOnline}
          accountUserId={currentUserId}
        />
      </CustomPopover>
    </>
  );
}
